import { Button, Spin, Alert, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useState } from "react";
import { ScheduleStore } from "./store";
import { ScheduleTimeline } from "./components/ScheduleTimeline";
import { ScheduleItemModal } from "./components/ScheduleItemModal";
import { AddScheduleItemModal } from "./components/AddScheduleItemModal";
import { usePermission } from "@opendash/core";

export const SchedulePage = observer(() => {
  const store = useMemo(() => new ScheduleStore(), []);
  const [addOpen, setAddOpen] = useState(false);
  const editPermission = usePermission("festival:timetable-admin");
  useEffect(() => { store.loadAll(); }, [store]);

  if (store.loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (store.error) {
    return <Alert type="error" message={store.error} style={{ margin: 24 }} />;
  }

  return (
    <div style={{ padding: "16px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <Typography.Title level={3} style={{ margin: 0 }}>Zeitplan</Typography.Title>
        {editPermission && (
          <Button type="primary" icon={<span className="fa fa-plus" />} onClick={() => setAddOpen(true)}>
            Hinzufügen
          </Button>
        )}
      </div>
      
      <ScheduleTimeline store={store} locations={store.locations} />

      {store.selectedItem && (
        <ScheduleItemModal store={store} locations={store.locations} />
      )}
      {editPermission && (
        <AddScheduleItemModal
          store={store}
          locations={store.locations}
          open={addOpen}
          onClose={() => setAddOpen(false)}
        />
      )}
    </div>
  );
});
